/**
 * Cliente de API para Organización, Sucursales y Usuarios del negocio.
 */

import { apiRequest } from "./api";
import type { BranchPublic, TenantPublic, UserPublic } from "./session";

export interface BranchListResponse {
  items: BranchPublic[];
  total: number;
}

export interface UserListResponse {
  items: UserPublic[];
  total: number;
}

export interface TenantUpdatePayload {
  name?: string;
  legal_name?: string | null;
  rfc?: string | null;
  tax_regime?: string | null;
  fiscal_postal_code?: string | null;
  timezone?: string | null;
  currency?: string | null;
  prices_include_tax?: boolean;
  business_day_cutoff_hour?: number;
  suggested_tip_percent?: number;
  settings?: Record<string, unknown> | null;
}

export interface BranchCreatePayload {
  name: string;
  code: string;
  address?: string;
  timezone?: string;
  phone?: string;
}

export interface UserCreatePayload {
  email: string;
  full_name: string;
  password: string;
  role_code: string;
  default_branch_id?: string;
  pin?: string;
  branch_ids?: string[];
}

export function getCurrentTenant(): Promise<TenantPublic> {
  return apiRequest("/api/v1/tenants/current");
}

export function updateCurrentTenant(payload: TenantUpdatePayload): Promise<TenantPublic> {
  return apiRequest("/api/v1/tenants/current", {
    method: "PATCH",
    body: payload,
  });
}

export function listBranches(): Promise<BranchListResponse> {
  return apiRequest("/api/v1/branches");
}

export function createBranch(payload: BranchCreatePayload): Promise<BranchPublic> {
  return apiRequest("/api/v1/branches", {
    method: "POST",
    body: payload,
  });
}

export function listUsers(): Promise<UserListResponse> {
  return apiRequest("/api/v1/users");
}

export function createUser(payload: UserCreatePayload): Promise<UserPublic> {
  return apiRequest("/api/v1/users", {
    method: "POST",
    body: payload,
  });
}

